import React from 'react';
import { Select } from 'evergreen-ui';
import Styled from 'styled-components';

const StyledSelect = Styled(Select)`
  select {
    color: #636465;
    border-radius: 5px;
    font-size: 15px;
    font-weight: 500;
  }
`;

const CustomSelect = props => {
  const { values } = props;
  console.log(props, values);
  return (
    <StyledSelect width="100%" height={45} marginTop={16} {...props}>
      {values.map(option => (
        <option key={option.value} value={option.value} selected={props.selected === option.value}>
          {option.label}
        </option>
      ))}
    </StyledSelect>
  );
};

const CountrySelect = props => (
  <CustomSelect
    {...props}
    values={[
      { label: 'UK', value: 'UK' },
      { label: 'Canada', value: 'canada' },
      { label: 'Australia', value: 'australia' },
    ]}
  />
);

export default CustomSelect;

export { CountrySelect };
